document.documentElement.classList.remove('no-js');

function normalizeProductOption(value) {
  var normalized = String(value || '')
    .toLowerCase()
    .replace(/^(color|colour|farbe|couleur)\s*:\s*/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\b(silver|silber|grey|gray|grau)\b/g, 'grey')
    .trim();

  if (/^(silver|silber|grey|gray|grau|light grey|light gray|heather grey|heather gray|melange grey|melange gray)$/.test(normalized)) {
    return 'grey';
  }

  return normalized;
}

function mediaMatchesColor(element, color) {
  if (!color) return true;
  var mediaAlt = normalizeProductOption(element.getAttribute('data-media-alt'));
  var mediaColors = String(element.getAttribute('data-media-colors') || '')
    .split('|')
    .map(normalizeProductOption)
    .filter(Boolean);

  var mediaAltParts = String(element.getAttribute('data-media-alt') || '')
    .split(/[,|;/_-]+/)
    .map(normalizeProductOption)
    .filter(Boolean);

  if (mediaAlt === color || mediaAlt.indexOf(color) !== -1) return true;
  if (mediaAltParts.indexOf(color) !== -1) return true;
  return mediaColors.indexOf(color) !== -1;
}

function showProductMedia(gallery, mediaId) {
  var mediaItems = gallery.querySelectorAll('[data-gallery-media]');
  var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

  mediaItems.forEach(function(item) {
    item.classList.toggle('is-hidden', item.getAttribute('data-media-id') !== mediaId);
  });

  thumbs.forEach(function(thumb) {
    thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === mediaId);
  });
}

function filterProductGallery(form, selectedColor, fallbackMediaId) {
  var productPage = form.closest('.product-page');
  if (!productPage) return;

  var gallery = productPage.querySelector('[data-product-gallery]');
  if (!gallery) return;

  var color = normalizeProductOption(selectedColor);
  var mediaItems = Array.from(gallery.querySelectorAll('[data-gallery-media]'));
  var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  var matchingThumbs = thumbs.filter(function(thumb) {
    return mediaMatchesColor(thumb, color);
  });
  var shouldFilter = Boolean(color);

  mediaItems.forEach(function(item) {
    var matches = shouldFilter ? mediaMatchesColor(item, color) : true;
    if (shouldFilter && !matchingThumbs.length && fallbackMediaId) {
      matches = item.getAttribute('data-media-id') === String(fallbackMediaId);
    }
    item.setAttribute('data-color-visible', matches ? 'true' : 'false');
    item.classList.add('is-hidden');
  });

  thumbs.forEach(function(thumb) {
    var matches = shouldFilter ? mediaMatchesColor(thumb, color) : true;
    if (shouldFilter && !matchingThumbs.length && fallbackMediaId) {
      matches = thumb.getAttribute('data-media-id') === String(fallbackMediaId);
    }
    thumb.classList.toggle('is-hidden', !matches);
    thumb.classList.remove('is-active');
  });

  var firstVisibleThumb = thumbs.find(function(thumb) {
    return !thumb.classList.contains('is-hidden');
  });

  if (firstVisibleThumb) {
    showProductMedia(gallery, firstVisibleThumb.getAttribute('data-media-id'));
  }
}

function variantMediaId(variant) {
  if (!variant || !variant.featured_media) return '';
  return variant.featured_media.id || '';
}

function selectedColorFromForm(form) {
  var colorInput = Array.from(form.querySelectorAll('[data-option-input]:checked')).find(function(input) {
    return /color|colour|farbe|couleur/i.test(input.name);
  });
  return colorInput ? colorInput.value : '';
}

function selectedVariant(form) {
  var variantData = form.querySelector('[data-variant-json]');
  if (!variantData) return null;

  var selected = Array.from(form.querySelectorAll('[data-option-select]')).map(function(select) {
    return select.value;
  });
  var variants = JSON.parse(variantData.textContent);

  return variants.find(function(item) {
    return item.options.every(function(option, index) {
      return option === selected[index];
    });
  }) || null;
}

document.addEventListener('change', function(event) {
  var input = event.target;
  if (!input.matches('[data-option-input]')) return;

  var form = input.closest('[data-product-form]');
  if (!form) return;

  var selects = form.querySelectorAll('[data-option-select]');
  selects.forEach(function(select) {
    var optionName = select.getAttribute('data-option-name');
    var checked = form.querySelector('input[name="' + CSS.escape(optionName) + '"]:checked');
    if (checked) {
      select.value = checked.value;
      var labelValue = form.querySelector('[data-option-label-value="' + CSS.escape(optionName) + '"]');
      if (labelValue) labelValue.textContent = checked.value;
    }
  });

  var variant = selectedVariant(form);

  var idInput = form.querySelector('[name="id"]');
  var button = form.querySelector('[type="submit"]');
  if (variant && variant.available) {
    idInput.value = variant.id;
    button.disabled = false;
    button.textContent = button.dataset.availableText;
  } else if (variant) {
    idInput.value = variant.id;
    button.disabled = true;
    button.textContent = button.dataset.soldOutText;
  }

  form.querySelectorAll('[data-option-input]').forEach(function(radio) {
    var label = radio.closest('[aria-checked]');
    if (label) label.setAttribute('aria-checked', radio.checked ? 'true' : 'false');
  });

  if (/color|colour|farbe|couleur/i.test(input.name)) {
    filterProductGallery(form, input.value, variantMediaId(variant));
  }
});

document.addEventListener('click', function(event) {
  var sizeGuideOpen = event.target.closest('[data-size-guide-open]');
  if (sizeGuideOpen) {
    var productPage = sizeGuideOpen.closest('.product-page');
    var sizeGuideModal = productPage ? productPage.querySelector('[data-size-guide-modal]') : null;
    if (sizeGuideModal) {
      sizeGuideModal.hidden = false;
      document.body.classList.add('size-guide-open');
    }
    return;
  }

  var sizeGuideClose = event.target.closest('[data-size-guide-close]');
  if (sizeGuideClose) {
    var openSizeGuideModal = sizeGuideClose.closest('[data-size-guide-modal]');
    if (openSizeGuideModal) openSizeGuideModal.hidden = true;
    document.body.classList.remove('size-guide-open');
    return;
  }

  var menuToggle = event.target.closest('[data-mobile-menu-toggle]');
  if (menuToggle) {
    var menuId = menuToggle.getAttribute('aria-controls');
    var menu = menuId ? document.getElementById(menuId) : null;
    if (menu) {
      menu.hidden = false;
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mobile-menu-open');
    }
    return;
  }

  var menuClose = event.target.closest('[data-mobile-menu-close]');
  if (menuClose) {
    var mobileMenu = menuClose.closest('[data-mobile-menu]');
    var mobileToggle = mobileMenu ? document.querySelector('[data-mobile-menu-toggle][aria-controls="' + CSS.escape(mobileMenu.id) + '"]') : null;
    if (mobileMenu) mobileMenu.hidden = true;
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-menu-open');
    return;
  }

  var thumb = event.target.closest('[data-gallery-thumb]');
  if (!thumb) return;

  var gallery = thumb.closest('[data-product-gallery]');
  if (!gallery) return;

  showProductMedia(gallery, thumb.getAttribute('data-media-id'));
});

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;

  var sizeGuideModal = document.querySelector('[data-size-guide-modal]:not([hidden])');
  if (sizeGuideModal) {
    sizeGuideModal.hidden = true;
    document.body.classList.remove('size-guide-open');
  }

  var mobileMenu = document.querySelector('[data-mobile-menu]:not([hidden])');
  if (mobileMenu) {
    mobileMenu.hidden = true;
    document.body.classList.remove('mobile-menu-open');
    var mobileToggle = document.querySelector('[data-mobile-menu-toggle][aria-expanded="true"]');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-product-form]').forEach(function(form) {
    var variant = selectedVariant(form);
    filterProductGallery(form, selectedColorFromForm(form), variantMediaId(variant));
  });

  initializeCountdowns(document);
  initializeLoopingVideos(document);
});

function initializeCountdowns(scope) {
  scope.querySelectorAll('[data-countdown]').forEach(function(countdown) {
    if (countdown._timer) clearInterval(countdown._timer);

    var target = new Date(countdown.getAttribute('data-countdown-target')).getTime();
    var expiredMessage = countdown.querySelector('[data-countdown-expired-message]');
    var units = countdown.querySelectorAll(':scope > div');

    function renderCountdown() {
      var distance = target - Date.now();

      if (!Number.isFinite(target) || distance <= 0) {
        units.forEach(function(unit) { unit.hidden = true; });
        if (expiredMessage) {
          expiredMessage.textContent = countdown.getAttribute('data-countdown-expired') || '';
          expiredMessage.hidden = false;
        }
        if (countdown._timer) clearInterval(countdown._timer);
        return;
      }

      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);

      countdown.querySelector('[data-countdown-days]').textContent = String(days).padStart(2, '0');
      countdown.querySelector('[data-countdown-hours]').textContent = String(hours).padStart(2, '0');
      countdown.querySelector('[data-countdown-minutes]').textContent = String(minutes).padStart(2, '0');
      countdown.querySelector('[data-countdown-seconds]').textContent = String(seconds).padStart(2, '0');
    }

    renderCountdown();
    countdown._timer = setInterval(renderCountdown, 1000);
  });
}

document.addEventListener('shopify:section:load', function(event) {
  initializeCountdowns(event.target);
  initializeLoopingVideos(event.target);
});

function initializeLoopingVideos(scope) {
  scope.querySelectorAll('.coming-soon__media video, .hero-video__media video').forEach(function(video) {
    video.autoplay = true;
    video.loop = true;
    video.defaultMuted = true;
    video.muted = true;
    video.volume = 0;
    video.playsInline = true;
    video.preload = 'auto';
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'auto');

    function replayVideo() {
      try {
        video.currentTime = 0;
      } catch (error) {}

      var play = video.play();
      if (play && typeof play.catch === 'function') play.catch(function() {});
    }

    if (!video.dataset.loopGuardBound) {
      video.addEventListener('ended', replayVideo);
      video.addEventListener('timeupdate', function() {
        if (!Number.isFinite(video.duration) || video.duration <= 1) return;
        if (video.currentTime >= video.duration - 0.2) replayVideo();
      });
      video.addEventListener('pause', function() {
        if (document.hidden) return;
        window.setTimeout(function() {
          if (video.paused) {
            var play = video.play();
            if (play && typeof play.catch === 'function') play.catch(function() {});
          }
        }, 150);
      });
      video.dataset.loopGuardBound = 'true';
    }

    var play = video.play();
    if (play && typeof play.catch === 'function') play.catch(function() {});
  });
}

document.addEventListener('visibilitychange', function() {
  if (!document.hidden) initializeLoopingVideos(document);
});

document.addEventListener('touchstart', function() {
  initializeLoopingVideos(document);
}, { once: true, passive: true });
